// extracted by mini-css-extract-plugin
module.exports = {"multiModal":"MultimediaModal_multiModal__1zW6b","zoomImg":"MultimediaModal_zoomImg__1sJ6r","videoContent":"MultimediaModal_videoContent__GgjRE"};